module.exports = __webpack_public_path__ + "img/LOGO.9bae05a3.png";